import React, { useState } from 'react';
import { 
  UserCheck, 
  UserX, 
  Send, 
  TrendingDown, 
  Link2, 
  Clock, 
  AlertCircle, 
  Check, 
  Sparkles,
  ArrowRight,
  ShieldAlert,
  Bell
} from 'lucide-react';

export default function AdminChurnAndFunnel({ funnel, inactiveAthletes = [], onRefresh }) {
  const [nudgingId, setNudgingId] = useState(null);
  const [nudgedSuccess, setNudgedSuccess] = useState({});

  const {
    invitationsSent = 0,
    registeredUsers = 0,
    connectedDevices = 0,
    activeLast7Days = 0
  } = funnel || {};

  const regRate = invitationsSent > 0 ? Math.round((registeredUsers / invitationsSent) * 100) : 100;
  const connectRate = registeredUsers > 0 ? Math.round((connectedDevices / registeredUsers) * 100) : 0;
  const activeRate = registeredUsers > 0 ? Math.round((activeLast7Days / registeredUsers) * 100) : 0;

  const handleNudge = async (athlete) => {
    try {
      setNudgingId(athlete.id);
      const token = localStorage.getItem('token');
      const API_URL = import.meta.env.VITE_API_URL || (window.location.hostname === 'localhost' ? 'http://localhost:3000/api' : '/api');
      
      const res = await fetch(`${API_URL}/admin/nudge-user`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
          userId: athlete.id,
          message: `¡Hola ${athlete.name.split(' ')[0]}! Notamos que llevas ${athlete.daysInactive} días sin registrar tus métricas ni entrenamientos. Recuerda que la constancia es la clave para que la IA y tu entrenador optimicen tu rendimiento.`
        })
      });

      if (!res.ok) throw new Error('Error al enviar recordatorio');

      setNudgedSuccess(prev => ({ ...prev, [athlete.id]: true }));
      setTimeout(() => {
        setNudgedSuccess(prev => ({ ...prev, [athlete.id]: false }));
      }, 4000);
    } catch (err) {
      alert(err.message);
    } finally {
      setNudgingId(null);
    }
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem', marginBottom: '2rem' }}>
      
      {/* HEADER EMBUDO & RADAR */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '0.8rem' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.6rem' }}>
          <div style={{ width: '36px', height: '36px', borderRadius: '10px', background: 'rgba(245, 158, 11, 0.15)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#f59e0b' }}>
            <UserCheck size={20} />
          </div>
          <div>
            <h3 style={{ margin: 0, fontSize: '1.25rem', color: 'white', fontWeight: 700 }}>Embudo de Conversión & Radar de Churn</h3>
            <p style={{ margin: 0, color: 'var(--text-muted)', fontSize: '0.85rem' }}>Adherencia de onboarding y detección proactiva de deportistas inactivos</p>
          </div>
        </div>

        {inactiveAthletes.length > 0 && (
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', background: 'rgba(239, 68, 68, 0.1)', border: '1px solid rgba(239, 68, 68, 0.25)', padding: '0.4rem 0.8rem', borderRadius: '20px' }}>
            <ShieldAlert size={16} color="#ef4444" />
            <span style={{ color: '#ef4444', fontSize: '0.8rem', fontWeight: 700 }}>{inactiveAthletes.length} atletas en riesgo</span>
          </div>
        )}
      </div>

      {/* 1. EMBUDO DE CONVERSIÓN VISUAL (FUNNEL) */}
      <div className="glass-panel" style={{ padding: '1.5rem', background: 'linear-gradient(145deg, rgba(15, 23, 42, 0.6) 0%, rgba(30, 41, 59, 0.4) 100%)' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.2rem' }}>
          <h4 style={{ margin: 0, color: 'white', fontSize: '0.95rem', fontWeight: 600 }}>Embudo de Adopción & Retención</h4>
          <span style={{ color: 'var(--text-muted)', fontSize: '0.8rem' }}>De la invitación al hábito de entrenamiento</span>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '1rem', alignItems: 'center' }}>
          
          {/* Step 1: Invitaciones */}
          <div style={{ background: 'rgba(255,255,255,0.03)', padding: '1rem', borderRadius: '12px', border: '1px solid rgba(255,255,255,0.06)', position: 'relative' }}>
            <div style={{ color: 'var(--text-muted)', fontSize: '0.75rem', fontWeight: 600, textTransform: 'uppercase', marginBottom: '0.3rem' }}>1. Invitaciones</div>
            <div style={{ fontSize: '1.6rem', fontWeight: 800, color: 'white' }}>{invitationsSent}</div>
            <div style={{ color: 'var(--text-secondary)', fontSize: '0.75rem', marginTop: '0.3rem' }}>Magic Links generados</div>
          </div>

          {/* Step 2: Registrados */}
          <div style={{ background: 'rgba(255,255,255,0.03)', padding: '1rem', borderRadius: '12px', border: '1px solid rgba(255,255,255,0.06)' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0.3rem' }}>
              <span style={{ color: 'var(--text-muted)', fontSize: '0.75rem', fontWeight: 600, textTransform: 'uppercase' }}>2. Cuentas Creadas</span>
              <span style={{ color: '#10b981', fontSize: '0.75rem', fontWeight: 700 }}>{regRate}%</span>
            </div>
            <div style={{ fontSize: '1.6rem', fontWeight: 800, color: 'var(--health-cyan)' }}>{registeredUsers}</div>
            <div style={{ color: 'var(--text-secondary)', fontSize: '0.75rem', marginTop: '0.3rem' }}>Deportistas onboarded</div>
          </div>

          {/* Step 3: Conectores */}
          <div style={{ background: 'rgba(255,255,255,0.03)', padding: '1rem', borderRadius: '12px', border: '1px solid rgba(255,255,255,0.06)' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0.3rem' }}>
              <span style={{ color: 'var(--text-muted)', fontSize: '0.75rem', fontWeight: 600, textTransform: 'uppercase' }}>3. Strava / Garmin</span>
              <span style={{ color: connectRate > 50 ? '#10b981' : '#f59e0b', fontSize: '0.75rem', fontWeight: 700 }}>{connectRate}%</span>
            </div>
            <div style={{ fontSize: '1.6rem', fontWeight: 800, color: 'var(--strava-orange)' }}>{connectedDevices}</div>
            <div style={{ color: 'var(--text-secondary)', fontSize: '0.75rem', marginTop: '0.3rem' }}>Con sincronización activa</div>
          </div>

          {/* Step 4: Activos 7d */}
          <div style={{ background: 'rgba(255,255,255,0.03)', padding: '1rem', borderRadius: '12px', border: '1px solid rgba(16, 185, 129, 0.2)', background: 'linear-gradient(145deg, rgba(16, 185, 129, 0.08) 0%, rgba(17, 24, 39, 0.6) 100%)' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0.3rem' }}>
              <span style={{ color: 'var(--health-green)', fontSize: '0.75rem', fontWeight: 600, textTransform: 'uppercase' }}>4. Activos (7d)</span>
              <span style={{ color: '#10b981', fontSize: '0.75rem', fontWeight: 700 }}>{activeRate}%</span>
            </div>
            <div style={{ fontSize: '1.6rem', fontWeight: 800, color: '#10b981' }}>{activeLast7Days}</div>
            <div style={{ color: 'var(--text-secondary)', fontSize: '0.75rem', marginTop: '0.3rem' }}>Entrenando esta semana</div>
          </div>

        </div>
      </div>

      {/* 2. RADAR DE ATLETAS INACTIVOS */}
      <div className="glass-panel" style={{ padding: '0', overflow: 'hidden' }}>
        <div style={{ padding: '1.25rem 1.5rem', borderBottom: '1px solid rgba(255,255,255,0.05)', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '0.5rem' }}>
          <div>
            <h4 style={{ margin: 0, color: 'white', fontSize: '1rem', fontWeight: 600, display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
              <Clock size={18} color="#f59e0b" /> Radar de Atletas Inactivos (≥ 5 días sin datos)
            </h4>
            <p style={{ margin: '0.2rem 0 0 0', color: 'var(--text-muted)', fontSize: '0.8rem' }}>Prevención de abandono mediante intervenciones y toques de motivación</p>
          </div>
          
          <span style={{ fontSize: '0.8rem', color: 'var(--text-secondary)', background: 'rgba(255,255,255,0.05)', padding: '0.3rem 0.8rem', borderRadius: '12px' }}>
            {inactiveAthletes.length} en seguimiento
          </span>
        </div>

        {inactiveAthletes.length === 0 ? (
          <div style={{ padding: '3rem 2rem', textAlign: 'center', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '0.8rem' }}>
            <div style={{ width: '48px', height: '48px', borderRadius: '50%', background: 'rgba(16, 185, 129, 0.1)', color: '#10b981', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <Check size={24} />
            </div>
            <div style={{ color: 'white', fontWeight: 600 }}>¡Todos los deportistas están activos!</div>
            <div style={{ color: 'var(--text-muted)', fontSize: '0.85rem', maxWidth: '400px' }}>No hay atletas con más de 5 días de inactividad registrada. La adherencia global está en niveles óptimos.</div>
          </div>
        ) : (
          <div style={{ overflowX: 'auto' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'left', fontSize: '0.9rem' }}>
              <thead>
                <tr style={{ background: 'rgba(255,255,255,0.02)', color: 'var(--text-muted)' }}>
                  <th style={{ padding: '0.8rem 1.2rem', fontWeight: 500 }}>Atleta</th>
                  <th style={{ padding: '0.8rem 1.2rem', fontWeight: 500 }}>Entrenador</th>
                  <th style={{ padding: '0.8rem 1.2rem', fontWeight: 500 }}>Inactividad</th>
                  <th style={{ padding: '0.8rem 1.2rem', fontWeight: 500 }}>Conexiones</th>
                  <th style={{ padding: '0.8rem 1.2rem', fontWeight: 500 }}>Último Registro</th>
                  <th style={{ padding: '0.8rem 1.2rem', fontWeight: 500, textAlign: 'right' }}>Acción</th>
                </tr>
              </thead>
              <tbody>
                {inactiveAthletes.map((athlete, idx) => {
                  const isSevere = athlete.daysInactive >= 10;
                  const isSuccess = nudgedSuccess[athlete.id];
                  const isLoading = nudgingId === athlete.id;

                  return (
                    <tr 
                      key={athlete.id || idx}
                      style={{ 
                        borderTop: '1px solid rgba(255,255,255,0.04)',
                        backgroundColor: idx % 2 === 0 ? 'transparent' : 'rgba(255,255,255,0.01)'
                      }}
                    >
                      {/* Atleta info */}
                      <td style={{ padding: '0.9rem 1.2rem' }}>
                        <div style={{ color: 'white', fontWeight: 600 }}>{athlete.name}</div>
                        <div style={{ color: 'var(--text-secondary)', fontSize: '0.75rem' }}>{athlete.email}</div>
                      </td>

                      {/* Coach */}
                      <td style={{ padding: '0.9rem 1.2rem', color: 'rgba(255,255,255,0.8)', fontSize: '0.85rem' }}>
                        {athlete.coachName}
                      </td>

                      {/* Días inactivo */}
                      <td style={{ padding: '0.9rem 1.2rem' }}>
                        <span 
                          style={{ 
                            display: 'inline-flex', 
                            alignItems: 'center', 
                            gap: '0.3rem',
                            padding: '0.2rem 0.6rem', 
                            borderRadius: '12px', 
                            fontSize: '0.75rem', 
                            fontWeight: 700,
                            background: isSevere ? 'rgba(239, 68, 68, 0.2)' : 'rgba(245, 158, 11, 0.2)',
                            color: isSevere ? '#ef4444' : '#f59e0b'
                          }}
                        >
                          {athlete.daysInactive} días sin datos
                        </span>
                      </td>

                      {/* Conexiones */}
                      <td style={{ padding: '0.9rem 1.2rem' }}>
                        <div style={{ display: 'flex', gap: '0.4rem' }}>
                          <span 
                            style={{ 
                              fontSize: '0.7rem', 
                              padding: '0.15rem 0.5rem', 
                              borderRadius: '4px',
                              background: athlete.connectedStrava ? 'rgba(252, 76, 2, 0.15)' : 'rgba(255,255,255,0.05)',
                              color: athlete.connectedStrava ? '#fc4c02' : 'var(--text-muted)',
                              border: `1px solid ${athlete.connectedStrava ? 'rgba(252, 76, 2, 0.3)' : 'rgba(255,255,255,0.08)'}`
                            }}
                          >
                            Strava
                          </span>
                          <span 
                            style={{ 
                              fontSize: '0.7rem', 
                              padding: '0.15rem 0.5rem', 
                              borderRadius: '4px',
                              background: athlete.connectedWithings ? 'rgba(0, 229, 255, 0.15)' : 'rgba(255,255,255,0.05)',
                              color: athlete.connectedWithings ? 'var(--health-cyan)' : 'var(--text-muted)',
                              border: `1px solid ${athlete.connectedWithings ? 'rgba(0, 229, 255, 0.3)' : 'rgba(255,255,255,0.08)'}`
                            }}
                          >
                            Withings
                          </span>
                        </div>
                      </td>

                      {/* Último Registro */}
                      <td style={{ padding: '0.9rem 1.2rem', color: 'var(--text-secondary)', fontSize: '0.8rem' }}>
                        {athlete.lastActivity ? (
                          <span>{athlete.lastActivity.type} ({new Date(athlete.lastActivity.startDate).toLocaleDateString()})</span>
                        ) : athlete.lastLoginAt ? (
                          <span>Login ({new Date(athlete.lastLoginAt).toLocaleDateString()})</span>
                        ) : (
                          <span style={{ color: 'var(--text-muted)' }}>Sin actividad registrada</span>
                        )}
                      </td>

                      {/* Botón de Nudge */}
                      <td style={{ padding: '0.9rem 1.2rem', textAlign: 'right' }}>
                        <button
                          onClick={() => handleNudge(athlete)}
                          disabled={isLoading || isSuccess}
                          style={{
                            background: isSuccess ? 'rgba(16, 185, 129, 0.2)' : 'rgba(139, 92, 246, 0.15)',
                            color: isSuccess ? '#10b981' : '#c4b5fd',
                            border: `1px solid ${isSuccess ? 'rgba(16, 185, 129, 0.4)' : 'rgba(139, 92, 246, 0.3)'}`,
                            padding: '0.35rem 0.8rem',
                            borderRadius: '6px',
                            cursor: isLoading || isSuccess ? 'default' : 'pointer',
                            fontSize: '0.8rem',
                            fontWeight: 600,
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: '0.4rem',
                            transition: 'all 0.2s'
                          }}
                        >
                          {isSuccess ? (
                            <>
                              <Check size={14} /> Enviado
                            </>
                          ) : isLoading ? (
                            'Enviando...'
                          ) : (
                            <>
                              <Bell size={14} /> Toque de Reactivación
                            </>
                          )}
                        </button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
      </div>

    </div>
  );
}
